module.exports = __webpack_public_path__ + "img/avatar4.64e51bd5.png";